exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".result{font-size:18px}.custom-input-box{background-color:#e9ecef;opacity:1;padding:.3rem .75rem;font-size:1rem;line-height:1.5;color:#495057;background-clip:padding-box;border:1px solid #c4cacf;border-radius:2px}.custom-btn{margin-left:-14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4db33603","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/components/phd/hcf-calculator.vue
// module id = 473
// module chunks = 0 1